import React from "react";
import moment from "moment";
import { Row, Col } from "react-bootstrap";

//Services
import Api from "../../services/api";
import api from "../../services/api";

//Styles
import "../../View/Prelude/prelude.css";
import "../../Components/reports/reports.css";
import "../../View/General/details.module.css";

//Components
import ExcelButton from "../exportExcelButton/ExportExcelButton";
import Button from "../commonButton/commonButton";

class ReportButtons extends React.Component {
  excelbutton = (event) => {
    if (this.props.excelData.length === 0) {
      alert("Preencha um campo de filtro");
      event.preventDefault();
    }
  };

  render() {
    return (
      <Row type="input" className="w-100 button-filter-temp">
        <ExcelButton
          onClick={this.excelbutton}
          data={this.props.excelData}
          filename={`${this.props.surnameFile}_${moment()
            .utc()
            .utcOffset("-03:00")
            .format("DDMMYY_HHmmss")}.csv`}
        />
        <Button
          size
          title="Gerar"
          icon="faGear"
          parentCallback={this.props.handleClick}
          noMargin
        />
      </Row>
    );
  }
}

export default ReportButtons;
